import { OAuth, useSelector } from '@tunasong/redux'
import { isEntityAccessDenied } from '../is-entity-access-denied.js'

/**
 * One notion of "this entity is denied to me" for the entity route, inline links and embeds (request-access spec
 * §7.4). A 401 only counts while the session is valid; otherwise re-authentication is the answer.
 */
export const useIsEntityAccessDenied = (error: unknown) => {
  const authData = useSelector(state => state.user.authData)
  return Boolean(error) && isEntityAccessDenied(error, !OAuth.isSessionExpired(authData))
}
